import React from 'react';
import { Link } from 'react-router-dom';
import { userportal as routes } from 'shared/routes';
import LinkedIn from '../../assets/linkedin.png';
import Google from '../../assets/google.png';
import styles from './Oauth.module.scss';

const Oauth = () => (
  <div className={styles.oauth}>
    <Link to={routes.oauth.linkedIn.login}>
      <img src={LinkedIn} className={styles.linkedin} alt="" />
    </Link>
    <Link to={routes.oauth.google.login}>
      <img src={Google} className={styles.google} alt="" />
    </Link>
  </div>
);
export default Oauth;
